import { useCallback, useEffect, useMemo, useState } from 'react';

import HierarchicalConfigure from '../hierarchical-report/configure';
import { usePivotData } from './Context';

export default function Sidebar({ value, configure, reportView, onApply }) {
  const pivotData = usePivotData()
  const { filterby, pivotby } = configure

  const defaultValue = useMemo(() => ({
    filterby: value.filterby || {},
    pivotby: pivotData.metric ? pivotData : pivotby.default
  }), [configure, value, pivotData])

  const parseOnApply = useCallback(({ filterby, pivotby }) => {
    const { cols, rows, metric, aggregator, sort } = pivotby
    onApply({
      filterby, pivotby, aggregator, sort,
      groupby: [...cols, ...rows],
      metrics: [metric],
      sortby: [`${metric} ${sort}`],
    })
  }, [onApply])

  useEffect(() => {
    if (defaultValue) {
      parseOnApply(defaultValue)
    }
  }, [])

  const handleApply = useCallback(({ filterby, pivotby }) => {
    const configure = { pivotby, filterby: {} }
    if (filterby) configure.filterby = parseFilters(filterby)
    parseOnApply(configure)
    return configure
  }, [parseOnApply])

  return <HierarchicalConfigure onApply={handleApply} onSelect={parseOnApply}
    store={reportView} value={defaultValue} configure={{ filterby, pivotby }} />
}

const parseFilters = filterby => Object.keys(filterby).reduce((filters, field) => {
  const items = filterby[field].items.map(item => item.getValue())
  if (items.length) return { ...filters, ...{ [field]: items } }
  return filters
}, {})
